import ProgressCircle from "@/pages/dashboard/components/ProgressCircle/ProgressCircle";
import { CompletenessType, useCompleteness } from "@/pages/dashboard/hooks/useCompleteness";
import { useDashboardYear } from "@/pages/dashboard/hooks/useDateRange";
import { roundToDigits } from "@/pages/dashboard/utils/formatters";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import Skeleton from "../Skeleton/Skeleton";
import styles from "./CompletenessIndicator.module.scss";

const completenessLabel = (completeness: number | undefined) => {
  if (completeness === undefined) return undefined;
  if (completeness === 1) return "Complete";
  return `${roundToDigits(completeness * 100, 0, 2)}% complete`;
};

const completenessIcon = (completeness: number | undefined) => {
  if (completeness === undefined) return undefined;
  if (completeness === 1) return <CheckCircleOutlined style={{ color: "#52C41A" }} />;
  if (completeness < 0.25)
    return (
      <ProgressCircle
        progress={completeness}
        color={"red"}
      />
    );
  return (
    <ProgressCircle
      progress={completeness}
      color={"yellow"}
    />
  );
};

export default function CompletenessIndicator({ type }: { type?: CompletenessType }) {
  const { year } = useDashboardYear();
  const { data, isLoading } = useCompleteness({ year, type });

  const completeness = data?.completeness;

  return (
    <Flex
      align="center"
      gap={8}
    >
      {completenessIcon(completeness)}
      {isLoading ? (
        <Skeleton style={{ width: 120, height: 16 }} />
      ) : (
        <span className={styles.label}>{completenessLabel(completeness)}</span>
      )}
    </Flex>
  );
}
